export const READ_ALONG_PLAYBACK_RATE = 1;
export const ARABIC_SPEECH_PLAYBACK_RATE = 0.85;
export const DEVICE_EXPLANATION_PLAYBACK_RATE = 0.95;

function isArabicLanguage(language) {
  return String(language ?? '').trim().toLowerCase().startsWith('ar');
}

export function getServerSpeechPlaybackRate(language) {
  return isArabicLanguage(language)
    ? ARABIC_SPEECH_PLAYBACK_RATE
    : READ_ALONG_PLAYBACK_RATE;
}

export function getDeviceExplanationPlaybackRate(language) {
  return isArabicLanguage(language)
    ? ARABIC_SPEECH_PLAYBACK_RATE
    : DEVICE_EXPLANATION_PLAYBACK_RATE;
}
